export default {
    /**
     * Maps selected filter statuses to status ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedStatuses (state) {
        return state.shopsList.filters.statuses.map((item) => item.id);
    },

    /**
     * Maps selected filter types to type ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedRequestTypes (state) {
        return state.shopsList.filters.request_types.map((item) => item.id);
    },

    /**
     * Maps selected filter drafters to drafter ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedDrafters (state) {
        return state.shopsList.filters.drafters.map((item) => item.id);
    },

    /**
     * Maps selected filter estimator to estimator ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedEstimators (state) {
        return state.shopsList.filters.estimators.map((item) => item.id);
    },

    /**
     * Maps selected filter PO owners to PO owners ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    listFilterSelectedPoOwners (state) {
        return state.shopsList.filters.po_owners.map((item) => item.id);
    },

    /**
     * Returns all selected filters.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    allFilterSelected (state) {
        return getAllFilters(state, 'shopsList');
    },

    /**
     * Maps selected filter statuses to status ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    actionRequiredFilterSelectedStatuses (state) {
        return state.actionRequiredList.filters.statuses.map((item) => item.id);
    },

    /**
     * Maps selected filter types to type ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    actionRequiredFilterSelectedRequestTypes (state) {
        return state.actionRequiredList.filters.request_types.map((item) => item.id);
    },

    /**
     * Maps selected filter drafters to drafter ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    actionRequiredFilterSelectedDrafters (state) {
        return state.actionRequiredList.filters.drafters.map((item) => item.id);
    },

    /**
     * Maps selected filter estimator to estimator ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    actionRequiredFilterSelectedEstimators (state) {
        return state.actionRequiredList.filters.estimators.map((item) => item.id);
    },

    /**
     * Maps selected filter PO owners to PO owners ID array.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    actionRequiredFilterSelectedPoOwners (state) {
        return state.actionRequiredList.filters.po_owners.map((item) => item.id);
    },

    /**
     * returns linked requests.
     *
     * @param state Vuex state
     *
     // * @returns {*[]}
     */
    actionRequiredFilterSelectedIncludeLinkedRequests (state) {
        return state.actionRequiredList.filters.include_linked_requests;
    },

    /**
     * Returns all selected filters.
     *
     * @param state Vuex state
     *
     * @returns {*[]}
     */
    actionRequiredAllFilterSelected (state) {
        return getAllFilters(state, 'actionRequiredList');
    },
};

function getAllFilters (state, baseProp) {
    let data = [];
    data = data.concat(state[baseProp].filters.statuses.map(obj => {
        return {
            ...obj,
            field: 'statuses',
        };
    }));
    data = data.concat(state[baseProp].filters.request_types.map(obj => {
        return {
            ...obj,
            field: 'request_types',
        };
    }));
    data = data.concat(state[baseProp].filters.drafters.map(obj => {
        return {
            ...obj,
            field: 'drafters',
        };
    }));
    data = data.concat(state[baseProp].filters.estimators.map(obj => {
        return {
            ...obj,
            field: 'estimators',
        };
    }));
    data = data.concat(state[baseProp].filters.po_owners.map(obj => {
        return {
            ...obj,
            field: 'po_owners',
        };
    }));
    if (state[baseProp].filters.include_linked_requests) {
        data = data.concat({name:'Include Linked Requests', field: 'include_linked_requests'});
    }

    return data;
}
